import { type AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type ConversionMap } from '../types/events'
import { sendLoginEvent } from './sendLoginEvent'
import { sendSignUpEvent } from './sendSignUpEvent'

export interface RegisterCosignEventsArgs {
  platforms?: AnalyticsPlatforms[]
  conversionMap?: ConversionMap
}
export const registerCosignEvents = (args?: RegisterCosignEventsArgs) => {
  sendSignUpEvent(args)
  sendLoginEvent(args)
}
